import React from 'react';
import moment from 'moment';
import Select from 'react-select';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import {connect as connectFormik} from 'formik';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import { selectDefaultStyles } from '../../../styling/selectDefaultStyles';
import { dataCorrectionAction, dataCorrectionType } from '../../../../store/repiStore';
import BbCheckbox from '../../../styling/bbCheckbox';
import BbDatePicker from '../../../common/datePicker';
import CustomTooltip from '../../../common/customTooltip';

import '../../repi.scss';

class RepiDataCorrectionInputField extends React.Component {
    get fieldName() { return `${this.props.rowId}.${this.props.name}`; }
    get actionName() { return `${this.props.rowId}.action`; }
    get fieldId() { return isNullOrUndefined(this.props.contractId)
        ? `${(this.props.sectionId)}-${this.props.name}-${this.props.rowId}`
        : `${this.props.name}-${(this.props.contractId)}-${this.props.rowId}`
    }

    render() {
        return (
            <>
                {this.renderInputByType()}
                {!isNullOrUndefined(this.props.error) && <CustomTooltip hideIcon
                    textAlign="right"
                    placement="right"
                    id={this.fieldId}
                    text={this.props.error}
                    innerClassName="repi-search-input-error-tooltip"
                />}
            </>
        )
    }

    renderInputByType = () => {
        const { value, type, options, placeholder, error, noMaxDate, isPending, enableDateReinitialize, afterDateReinitialized, isWarning } = this.props;

        switch (type) {
            case dataCorrectionType.list:
                const selectedOption = options.find(option => option.value === value);
                return <Select
                    className="repi-data-correction-select"
                    closeMenuOnSelect={true}
                    field={this.fieldName}
                    value={selectedOption}
                    styles={selectDefaultStyles}
                    isSearchable={true}
                    options={options}
                    hideSelectedOptions={false}
                    allowSelectAll={false}
                    onChange={this.onListChange}
                    isDisabled={isPending}
                    placeholder={placeholder}
                    formatOptionLabel={({ value, label }) => (
                        <div style={{ display: "flex" }}>
                            <span style={{minHeight: "1em", textAlign: "left", fontSize: "0.75em", whiteSpace: "nowrap" }} type={value} size="medium">
                                {label}
                            </span>
                        </div>
                    )}
                />;
            case dataCorrectionType.date:
                return <BbDatePicker hideIcon allowInvalidValue
                    enableReinitialize={enableDateReinitialize}
                    id={this.fieldId}
                    afterDateChange={this.onDateChange}
                    value={value && moment(value, moment.ISO_8601, true).isValid() ? new Date(value) : value}
                    hasValidationError={!isNullOrUndefined(error)}
                    field={this.fieldName}
                    style={{ margin: "0 auto", height: "100%" }}
                    yearsBack={120}
                    disabled={isPending}
                    name={this.fieldId}
                    noMaxDate={noMaxDate}
                    afterReinitialize={afterDateReinitialized}
                    additionalClasses={{ "is-warning": isWarning }}
                />;
            case dataCorrectionType.bool:
                return <BbCheckbox
                    id={this.fieldName}
                    value={value}
                    disabled={isPending}
                    onChange={(v) => this.onFieldChange(v)}
                />;
            default:
                return <input
                    id={this.fieldId}
                    className={classnames("repi-data-correction-field-input input", {
                        "is-danger": !isNullOrUndefined(error),
                        "is-warning": isWarning
                    })}
                    height="100%"
                    type="text"
                    value={isNullOrUndefined(value) ? "" : value}
                    field={this.fieldName}
                    name={this.fieldId}
                    onChange={this.onInputChange}
                    disabled={isPending}
                />;
        }
    }

    onDateChange = (value, isValid) => {
        if (value === "") {
            this.onFieldChange("");
        } else if (!isValid) {
            this.onFieldChange(value);
            return;
        }
        else {
            var validatedDate = moment(value, ["D.M.YYYY", "DD.M.YYYY", "D.MM.YYYY", "DD.MM.YYYY"], true);
            this.onFieldChange(validatedDate.isValid() ? validatedDate.toISOString() : "");
        }
    }

    onInputChange = (e) => {
        let value = e;

        if (!isNullOrUndefined(e.target))
            value = e.target.value;
        else if (!isNullOrUndefined(e.value))
            value = e.value;
        else if (isNullOrUndefined(value))
            value = "";

        this.onFieldChange(value);
    }

    onFieldChange = (value) => {
        this.props.setFieldValue(this.fieldName, value);

        if (!this.props.isNew)
            this.props.setFieldValue(this.actionName, dataCorrectionAction.update);
    }

    onListChange = (selected) => this.onFieldChange(selected.value);
}

export default connectFormik(connect(
    state => state.userContext,
    null
)(withLocalize(withRouter(RepiDataCorrectionInputField))));
